import { useField } from "formik";
import { useCallback } from "react";

export const useAddRemoveMachineGroups = () => {
  console.log(useField<any>("group_list"));

  const [{ value: groups }, , { setValue: setGroups, setError }] =
    useField<any>("group_list");

  const isAlreadyAdded = (group: any) => {
    return group?.id && groups?.find((c: any) => c.id == group.id);
  };

  const addGroups = useCallback(
    (toAdd: any[]) => {
      const addedGroups = toAdd
        .filter((c) => !isAlreadyAdded(c))
        .map((group) => {
          const { id, name, created_date, updated_date, machine_count } = group;
          return {
            id: id,
            name: name,
            created_date: created_date,
            updated_date: updated_date,
            machine_count: machine_count,
          };
        });
      setGroups([...(groups ?? []), ...addedGroups]);
      return addedGroups;
    },
    [groups, setGroups]
  );

  const removeGroups = useCallback(
    (toRemove: { id: string }[]) => {
      const idsToRemove = toRemove.map((d: any) => d.id);
      setGroups(groups.filter((c: any) => !idsToRemove.includes(c.id!)));
      setError(undefined);
    },
    [groups, setGroups]
  );

  return {
    groups,
    isAlreadyAdded,
    addGroups,
    removeGroups,
  };
};
